export default __webpack_public_path__ + "cd72d2cd45a19ad779d4082076383c5c.jpeg";